import { get } from '../../utils/get';
import { updateValueByIdentifier } from '../../tags/values/update-by-identifier';
import { IDENTIFIERS } from '../../types/Identifiers';
import { getKeys, hasMissingSchemaVariables } from '../../adapters/utils';
import { getProductFullUrl } from './calculated/get-product-full-url';
import { SD_STATUS } from '../../consts';
import { IDs } from './ids-stores-product';
import { requiredSchemaVariables } from './required-schema-variables';
import { isV3Product, getV3ProductData } from './get-v3-stores-product-data';
import { getV1ProductData } from './get-v1-stores-product-data';
var userVisible = [
    IDs.SITE_NAME,
    IDs.SKU,
    IDs.TITLE,
    IDs.DESCRIPTION,
    IDs.BRAND,
    IDs.PRICE,
    IDs.CURRENCY,
    IDs.AVAILABILITY_META_TAG,
    IDs.PAGE_URL,
    IDs.MAIN_IMAGE,
];
var userVisibleSdOnly = [
    IDs.IMAGE_HEIGHT,
    IDs.IMAGE_WIDTH,
    IDs.IMAGE_ALT,
    IDs.THUMBNAIL_URL,
    IDs.THUMBNAIL_HEIGHT,
    IDs.THUMBNAIL_WIDTH,
    IDs.THUMBNAIL_ALT,
    IDs.AVAILABILITY_SCHEMA,
    IDs.SD_JSON_IMAGES,
];
var SchemaTypes = {
    STORES_PRODUCT_PAGE: 'stores-product-page-preset',
};
var getSdStatus = function (item, itemData) {
    if (hasMissingSchemaVariables(requiredSchemaVariables, item, itemData)) {
        return SD_STATUS.DISABLED_DUE_TO_MISSING_INFO;
    }
    return SD_STATUS.ENABLED;
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    requiredSchemaVariables: requiredSchemaVariables,
    getData: function (item) {
        if (isV3Product(item)) {
            return getV3ProductData(item);
        }
        return getV1ProductData(item);
    },
    getSdStatus: getSdStatus,
    getLegacySeoBlob: function (item) {
        var tags = updateValueByIdentifier([], IDENTIFIERS.TITLE, get(item, 'legacySeoData.title'));
        tags = updateValueByIdentifier(tags, IDENTIFIERS.DESCRIPTION, get(item, 'legacySeoData.description'));
        return { tags: tags };
    },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return getKeys(IDs, userVisibleSdOnly); },
    getSlug: function (item) {
        return get(item, 'product.slug');
    },
    setFullUrl: function (itemData, url) {
        if (url === void 0) { url = ''; }
        if (isV3Product(itemData)) {
            var updatedItemData_1 = JSON.parse(JSON.stringify(itemData));
            updatedItemData_1.product.url.url = url;
            return updatedItemData_1;
        }
        var updatedItemData = JSON.parse(JSON.stringify(itemData));
        updatedItemData.product.productPageUrl.path = url;
        return updatedItemData;
    },
    getFullUrl: function (itemData) {
        if (isV3Product(itemData)) {
            return get(itemData, 'product.url.url') || getProductFullUrl(itemData);
        }
        return getProductFullUrl(itemData);
    },
    updateItemDataWithSlug: function (itemData, slugValue) {
        var updatedItemData = JSON.parse(JSON.stringify(itemData));
        if (get(updatedItemData, 'product.slug') !== '') {
            updatedItemData.product.slug = slugValue;
        }
        return updatedItemData;
    },
    getDefaultSchemaType: function () {
        return SchemaTypes.STORES_PRODUCT_PAGE;
    },
};
